import apiClient from './api';

const transactionService = {
  getAll: async () => apiClient.get('/transactions'),
  create: async (transactionData) => apiClient.post('/transactions', transactionData),
  // 3 sep 2026 (Augusto: "no existe la opcion para transferir de cuenta a
  // cuenta o a tarjetas"): crea las dos Transaction enlazadas (egreso en
  // origen + ingreso en destino) -- ver POST /transactions/transferencia.
  crearTransferencia: async (payload) => apiClient.post('/transactions/transferencia', payload),
  update: async (id, transactionData) => apiClient.put(`/transactions/${id}`, transactionData),
  delete: async (id) => apiClient.delete(`/transactions/${id}`),
  getSummary: async () => apiClient.get('/transactions/summary'),
  getByCategory: async (category) => apiClient.get(`/transactions/category/${category}`),
  getByDateRange: async (startDate, endDate) =>
    apiClient.get('/transactions/date-range', { params: { start_date: startDate, end_date: endDate } }),
};

export default transactionService;
